import React from "react";
import { Controller } from "react-hook-form";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import { useNavigate, useParams } from "react-router";
import FormLoading from "../../../components/FormLoading";
import { useCrudForm } from "../../../hooks/crud/Form";
import { useTranslation } from "react-i18next";

const Form = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { id } = useParams();
  const repository = new ParkingZoneRepository();
  const { form, onSubmit, isSubmitting, hasError, errorMessage } = useCrudForm(
    repository,
    { id: id, onSuccess: () => navigate("/app/parking-zones") }
  );
  const { control } = form;

  return (
    <form onSubmit={onSubmit}>
      <Grid item xs={12} lg={8}>
        {isSubmitting && <FormLoading />}`{" "}
        <Card>
          <CardHeader title={t("Information")} />
          <Divider />
          <CardContent>
            <Box mt={3}>
              <Controller
                as={TextField}
                control={control}
                error={hasError("Name")}
                fullWidth
                helperText={errorMessage("Name")}
                label={t("Name")}
                type={"text"}
                name="Name"
                defaultValue={""}
                variant="outlined"
              />
            </Box>
            <Box mt={3}>
              <Controller
                as={TextField}
                control={control}
                error={hasError("IntegrationId")}
                fullWidth
                type={"text"}
                helperText={errorMessage("control")}
                label={t("Integration Id")}
                name="IntegrationId"
                defaultValue={""}
                variant="outlined"
              />
            </Box>
          </CardContent>
        </Card>
        <Box mt={3}>
          <Card>
            <CardHeader title={t("Zone extra settings")} />
            <Divider />
            <CardContent>
              <Controller
                as={TextField}
                control={control}
                error={hasError("LongParkingTimeMinutes")}
                helperText={errorMessage("LongParkingTimeMinutes")}
                label={t("Long parking threshold (minutes)")}
                type="number"
                length={3}
                name="LongParkingTimeMinutes"
                variant="outlined"
                defaultValue={null}
              />
              <Box mt={3}>
                <Controller
                  name="IsActive"
                  control={control}
                  defaultValue={false}
                  render={({ value, onChange, checked }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={value}
                          value={value}
                          onChange={(event, value) => onChange(value)}
                        />
                      }
                      label={t("Active")}
                    />
                  )}
                />
              </Box>
            </CardContent>
          </Card>
        </Box>
        `
      </Grid>
      <Box mt={2}>
        <Button
          color="secondary"
          variant="contained"
          type="submit"
          name="submit"
          disabled={isSubmitting}
        >
          {t("Save")}
        </Button>
      </Box>
    </form>
  );
};

export default Form;
